 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		36: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"component---src-pages-404-js","3":"component---src-pages-chitchat-cms-js","4":"component---src-templates-article-404-template-js","5":"component---src-templates-blog-about-template-js","6":"component---src-templates-blog-post-template-js","7":"component---src-templates-blog-start-page-template-js","8":"component---src-templates-faq-template-js","9":"component---src-templates-frank-slideshow-template-js","10":"component---src-templates-game-template-js","11":"component---src-templates-kp-slideshow-template-js","12":"component---src-templates-kp-start-page-template-js","13":"component---src-templates-lucas-slideshow-template-js","14":"component---src-templates-lucas-start-page-template-js","15":"component---src-templates-mathilda-slideshow-template-js","16":"component---src-templates-memory-template-js","17":"component---src-templates-meo-template-js","18":"component---src-templates-my-hospital-book-template-js","19":"component---src-templates-podcast-template-js","20":"component---src-templates-quiz-template-js","21":"component---src-templates-room-template-1-js","22":"component---src-templates-room-template-2-js","23":"component---src-templates-room-template-3-js","24":"component---src-templates-room-template-4-js","25":"component---src-templates-room-template-5-js","26":"component---src-templates-room-template-6-js","27":"component---src-templates-room-template-7-js","28":"component---src-templates-room-template-8-js","29":"component---src-templates-start-page-template-js","30":"component---src-templates-teenage-info-template-js","31":"component---src-templates-text-page-template-js","32":"component---src-templates-the-operation-game-template-js","33":"component---src-templates-vo-template-js"}[chunkId]||chunkId) + "-" + {"2":"d21447b5c497a90687c4","3":"8c61536280a4afe652c7","4":"e5924f956ac647c67a53","5":"49a5a7ba1d917f956f62","6":"4cf5a49f5f9f53412b65","7":"26e57106fc31cc5f97ac","8":"732b826b8ca22165bd4f","9":"d3ed4100cd8b4a75e790","10":"60c5029375db9d118609","11":"b3bcdbb78d619662f46c","12":"3c08d4e8a2cb708272d2","13":"912a40857479dba577d6","14":"70b115db636f98048aee","15":"9d1fb1b5c6bf8e236600","16":"b59521c251de16d8b5d8","17":"b468b72989edcf3fdfcd","18":"a8b6d9d8999eed6eaad3","19":"caa288b2e229562bc0a6","20":"9695e19a6f7608df14a4","21":"657bea95d70b01abc728","22":"e893f707d26ea8cd5642","23":"b069e1076b7d89dc5a52","24":"7582e4f06fe6fd9efc27","25":"3ce681123538c6d5ac50","26":"7644d88356e9e5975f95","27":"267e3eb39d53933317ce","28":"66160cb7e9551a615d3d","29":"f929e6db226c5204ba48","30":"cdb175b48f492e6fd710","31":"3157580641da90861276","32":"d3b0a099583082887d82","33":"31d88baed68d9fa20405","37":"803066cf0d676a6c9fa1","38":"52015035b0d443303253","39":"05fe882ada5fa19ff214","40":"02f0932834b7dd5cbed5","41":"931adee94d95d8f9c6f7","42":"c0a9addeacb36dff5bfe","43":"3029d337eddbe660c219","44":"4403f23650976ea91244","45":"9a30659cd0fc1bef1d9f","46":"3434410752dcea1da89e","47":"0c57f512a4acfa46d094","48":"34829cd170e6dfbf6512","49":"c7274fd7fe7a5078da86","50":"f1ed78b95f2c0f231be9","51":"58c595af3c8e8cc56dfd","52":"afd947a834458add229d","53":"427c1a41381936b27f93","54":"bf5406a73790828cf853","55":"484927703435e4e3f40e","56":"ebe9ec22dbd22c17f26d","57":"b9a4f1dc53fec31e524d","58":"13d3ead1e67a2641bd3d","59":"f278f6ded0cd716b476d","60":"7447400a2762d0bc5826","61":"6d98456bbaae705afd43","62":"06d01632681e0adc7cbc","63":"387a2a105c2f0edba9b7","64":"37bc56593526e8381b69","65":"50010b29af3d0181bf79","66":"923a506cfe2179b4fc6e","67":"3e2d199f185ae6a03678","68":"99e8d58dc1666313f271","69":"e55367767f296e03393c","70":"d20ba0b0ffe2fec9fcc8","71":"60f7830aed46f30facd6","72":"a41c1ba231168cad4d48","73":"0b8095b389c091464b35","74":"82b1b2b2fef039a7584d","75":"e0752c0ac3181c09c6ba","76":"47ca254c9eded4ab19d4","77":"9559bf68a788999f39f3","78":"f27995862036ab5df3b2","79":"351aeaa1e87cc563146e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
